import React, {useEffect, useState} from "react";
import apiRequests from "../../Component/axios/config/config";
import {Upload} from "lucide-react";
import {FiTrash2} from "react-icons/fi";
import Loading from "../../Component/Loading/Loading";
import {VscGitStashApply} from "react-icons/vsc";
import toast from "react-hot-toast";
import axios from "axios";
import {useNavigate} from "react-router-dom";


export default function MultiBanner() {

    const [loading, setLoading] = useState(false);
    const [loadingImage, setLoadingImage] = useState(false);
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState({status: false, id: null});

    const [imageUrl, setImageUrl] = useState("");
    const [imageID, setImageID] = useState("");

    const [isFirst, setIsFirst] = useState(false);

    const [getListBanner, setListBanner] = useState([]);

    const [pathSelected, setPathSelected] = useState("MAIN");

    const paths = [
        {name: "home", Type: "MAIN"},
        {name: "Grocery Store", Type: "PRODUCT"},
        {name: "Order Food", Type: "FOOD"},
    ]

    useEffect(() => {
        getApi()
    }, [pathSelected]);

    const navigate = useNavigate();
    function getApi() {

        setLoading(true);
        apiRequests.get(`/api/banner/get-all`, {
            params: {
                is_slide: false,
                Type: pathSelected
            }
        })
            .then(res => {
                setListBanner(res.data.data);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }

            })
            .finally(() => setLoading(false))
    }

    function readImage() {
        document.querySelector('#profile')?.click();
    }

    function UploadImage(e) {

        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        setLoadingImage(true);

        apiRequests.post(`/api/file/v1/upload-admin`, formData, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                "Content-Type": "multipart/form-data",
            },
        })
            .then((response) => {
                setImageUrl(process.env.REACT_APP_API_URL + response.data.message.path);
                setImageID(response.data.message._id);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Error uploading image. Try again.");
            })
            .finally(() => {
                setLoadingImage(false);
            });
    }

    function removeImage(imgTarget) {

        setImageUrl(prevImages =>
            prevImages.filter(img => img !== imgTarget)
        );

    }

    function UploadBanners() {

        setLoadingEdit(true)

        const data = {
            image: imageID,
            is_first: isFirst,
            is_slide: false,
            is_automatic: false,
        }

        apiRequests.post(`/api/banner/create`, data)
            .then(() => {
                toast.success("upload image file successfully!")
                setImageID("")
                setImageUrl("")
                setIsFirst(false)
                getApi()
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Error uploading banner.");
            })
            .finally(() => {
                setLoadingEdit(false)
            })

    }

    function removeImageForBanner(id) {

        setDeleteLoading({status: true, id: id});
        apiRequests.delete(`/api/banner/delete`, {
            data: {
                id: id
            }
        })
            .then(() => {
                toast.success("delete image successfully!")
                getApi()
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Error deleting banner.");
            })
            .finally(() => {
                setDeleteLoading({status: false, id: null});
            })
    }


    return (


        <div className="p-6">

            <div className="flex gap-32 md:justify-between sm:flex-col sm:gap-6 items-center mb-6">
                <div className="text-3xl font-bold text-gray-800 sm:text-left sm:w-full">
                    Multi Banner
                </div>
                <div
                    className={`w-fit flex justify-center gap-12 items-center md:gap-10 sm:items-end`}>

                    {paths.map((item, index) => {

                        return (
                            <button
                                onClick={() => {
                                    setPathSelected(item.Type)
                                }}
                                key={index}
                                className={`${pathSelected === item.Type ? "border-b border-[#FF8C42] text-[#FF8C42]" : "text-black border-none"} text-lg sm:text-[16px] font-bold`}
                            >
                                {item.name}
                            </button>
                        )
                    })}

                </div>
            </div>


            <div className="font-bold">
                You can upload multiple banners for the home page of the site.
            </div>

            <div className="mt-6">
                <label className="block mb-2 font-medium">Image</label>
                <div className="flex flex-wrap gap-4">


                    {imageUrl && (

                        <div className="relative group">
                            <img
                                src={imageUrl}
                                alt="Preview"
                                className="w-32 h-32 object-cover rounded-lg border"
                            />

                            <button
                                type="button"
                                onClick={removeImage}
                                className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100
                                                opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                            >
                                <FiTrash2 className="w-4 h-4 text-red-600"/>
                            </button>

                        </div>
                    )}


                    <label
                        className="w-32 h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                        {!loadingImage &&
                            <input
                                type="file"
                                accept="image/*"
                                onClick={(e) => {
                                    if (getListBanner.length >= 4) {
                                        e.preventDefault();
                                        toast.error("You can upload up to 4 images only!");
                                        return;
                                    } else {
                                        readImage();
                                    }
                                }}
                                onChange={UploadImage}
                                className="hidden"
                            />

                        }

                        <div className="text-center text-gray-500">
                            {loadingImage ?

                                <div className="mx-auto mb-2">
                                    <svg aria-hidden="true"
                                         className="inline w-5 h-5 text-white animate-spin dark:text-gray-600 fill-white"
                                         viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="currentColor"/>
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentFill"/>
                                    </svg>
                                </div>
                                :
                                <Upload className="mx-auto mb-2"/>
                            }

                            <span>
                                        {loadingImage ?
                                            "Uploading..."
                                            :
                                            "Upload Images"
                                        }

                                    </span>
                        </div>
                    </label>
                </div>

                <div className="flex items-center gap-2 mt-4">
                    <button
                        onClick={() => setIsFirst(!isFirst)}
                        className={`relative w-9 h-6 rounded-full transition-colors duration-300 ${
                            isFirst ? "bg-green-500" : "bg-gray-300"
                        }`}
                    >
                    <span
                        className={`absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform duration-300 ${
                            isFirst ? "translate-x-3" : "translate-x-0"
                        }`}
                    />
                    </button>

                    <p>Is the First slide</p>
                </div>

                <button
                    onClick={UploadBanners}
                    className="flex items-center mt-10 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg gap-2"
                >
                    {loadingEdit ?
                        <Loading textColor={"white-0"}/>
                        :
                        <>
                            <VscGitStashApply className="w-4 h-4"/>
                            Upload Image
                        </>
                    }

                </button>

            </div>


            <div
                className="flex flex-col items-center justify-center border-2 border-marginColor-shade2 rounded-lg p-8 flex-wrap gap-4 mt-16">
                <label className="mb-2 font-medium">List of Image banner :</label>


                {loading ?
                    <Loading/>
                    :
                    <div className="gap-12 grid grid-cols-2 w-full">
                        {getListBanner.length > 0 ? (
                            getListBanner.map((item, index) => (
                                <div
                                    key={index}
                                    className="border-2 border-[#4d5461] rounded-xl flex items-center justify-center w-full sm:w-1/2 h-48 relative group"
                                >
                                    <img
                                        src={`${process.env.REACT_APP_API_URL}${item.image.path}`}
                                        alt={`banner-${index}`}
                                        className="object-cover max-h-full max-w-full"
                                    />

                                    <button
                                        type="button"
                                        onClick={() => removeImageForBanner(item._id)}
                                        className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                    >
                                        {deleteLoading.id === item._id && deleteLoading.status
                                            ? (
                                                <Loading/>
                                            ) : (
                                                <FiTrash2 className="w-4 h-4 text-red-600"/>
                                            )}
                                    </button>
                                </div>
                            ))
                        ) : (
                            <p className="col-span-2 text-center text-gray-500 w-full">No banners uploaded yet.</p>
                        )}
                    </div>

                }

            </div>


        </div>
    )
}